import invariant from 'tiny-invariant';

/**
 * Returns a new list by plucking the same named property off all objects in the list supplied.
 * @param {string} key
 * @param {array} array
 * @returns {array}
 */

function pluck(key, array) {
  invariant(key != null, '"key" was not provided.');
  invariant(Array.isArray(array), "Incorrect type. Expected array.");
  return array.map(item => item[key]);
}

export { pluck };
